import { RefObject, useEffect } from "react";
import { addUserEventSourceListener } from "@/common/hooks/event-source/useUserApiEventSource.ts";
import { SEGMENT_UPDATE } from "@/common/sse-api-event-source-message-types";
import { Segment } from "peaks.js";
import { disablePeaksEditSegmentMode } from "@/features/Waveform/utils.ts";
import useCurrentExplorerItemId from "@/common/hooks/useCurrentExplorerItemId.ts";
import { useMutateExplorerItems } from "@/state/jotai/hooks/useMutateExplorerItems.ts";

function useSegmentUpdate(eventSourceRef: RefObject<EventSource | null>) {
  const [currentExplorerItemId] = useCurrentExplorerItemId();
  const { upsertTrackSegment } = useMutateExplorerItems();

  // SEGMENT_UPDATE Listener
  useEffect(() => {
    if (!eventSourceRef.current) return;

    const handleSegmentUpdate = (e: MessageEvent) => {
      const { explorerItemId, segment, uniqueTabId: tabId } = JSON.parse(e.data) as {
        explorerItemId: string;
        segment: Segment;
        uniqueTabId: string;
      };

      if (currentExplorerItemId !== explorerItemId) {
        return;
      }

      disablePeaksEditSegmentMode();
      upsertTrackSegment(explorerItemId, segment, tabId);
    };

    const removeListener = addUserEventSourceListener(
      eventSourceRef.current,
      SEGMENT_UPDATE,
      handleSegmentUpdate,
    );

    // Cleanup
    return () => {
      removeListener();
    };
  }, [
    currentExplorerItemId,
    eventSourceRef,
    upsertTrackSegment
  ]);
}

export default useSegmentUpdate;
